//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HeartIcon from '~/assets/icon/heart-solid.svg?inline';
import addMutation from '@/queries/mutations/addToWishlist.graphql';
import removeMutation from '@/queries/mutations/removeFromWishlist.graphql';

export default {
    components: { HeartIcon },
    props: ['sku', 'smallIcon'],
    data() {
        return {
            errors: [],
        };
    },
    computed: {
        isInWishlist() {
            const skus = this.$store.state.wishlist.wishlist?.items_v2?.items?.map((item) => item.product.sku) || [];

            return skus.includes(this.sku);
        },
    },
    methods: {
        async add() {
            if (this.$store.state.wishlist.loading) {
                return;
            }

            if (!this.$store.state.auth.loggedIn) {
                this.$notify.error(this.$t('account.wishlist.loggedout'));

                return;
            }
            await this.$store.dispatch('wishlist/setLoading', true);
            this.errors = [];
            const {
                data: { addProductsToWishlist },
            } = await this.$apollo.mutate({
                mutation: addMutation,
                variables: {
                    id: this.$store.state.wishlist.wishlist.id,
                    input: [{ sku: this.sku, quantity: 1 }],
                },
            });
            await this.$store.dispatch('wishlist/setLoading', false);

            if (!addProductsToWishlist.user_errors.length) {
                await this.$store.dispatch('wishlist/getWishlist');
            } else {
                this.errors = addProductsToWishlist.user_errors;
            }
        },
        async remove() {
            if (this.$store.state.wishlist.loading) {
                return;
            }

            if (!this.$store.state.auth.loggedIn) {
                this.$notify.error(this.$t('account.wishlist.loggedout'));

                return;
            }
            await this.$store.dispatch('wishlist/setLoading', true);

            const currentItem = this.$store.state.wishlist.wishlist.items_v2.items.find((item) => item.product.sku === this.sku);
            this.errors = [];
            const {
                data: { removeProductsFromWishlist },
            } = await this.$apollo.mutate({
                mutation: removeMutation,
                variables: {
                    id: this.$store.state.wishlist.wishlist.id,
                    input: [currentItem.id],
                },
            });
            await this.$store.dispatch('wishlist/setLoading', false);

            if (!removeProductsFromWishlist.user_errors.length) {
                await this.$store.dispatch('wishlist/getWishlist');
            } else {
                this.errors = removeProductsFromWishlist.user_errors;
            }
        },
    },
};
